import { Component, OnInit } from "@angular/core";
import { ElectionService } from "../election.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { ConfirmSnackbarComponent } from "../confirm-snackbar/confirm-snackbar.component";
import { LogService } from "../services/log.service";

@Component({
  selector: "app-election",
  templateUrl: "./election.component.html",
  styleUrls: ["./election.component.css"]
})
export class ElectionComponent implements OnInit {
  constructor(
    public electionService: ElectionService,
    public snackbar: MatSnackBar,
    public bottomSheet: MatBottomSheet,
    public log: LogService
  ) {}

  public passportPath = "http://localohst:8080/ntertA/edozzier/uploads/";
  public electionArr = [];
  public officeArr = [];
  public selectedElection;
  public;
  ngOnInit() {
    this.log
      .addLog({
      action: "Access",
      component: "Election",
      details: `Accessed Election`,
    }).subscribe(data => { });
    this.electionService.getElections().subscribe(data => {
      this.electionArr = data;
      if (this.electionArr.length > 0) {
        this.selectedElection = this.electionArr[0];
      }
      this.getOffices();
    });
  }

  getOffices() {
    this.electionService
      .getElectionOffices({ election_id: this.selectedElection.election_id })
      .subscribe(
        data => {
          this.officeArr.length = 0;
          let officeArr = JSON.parse(JSON.stringify(data));
          officeArr.map(office => {
            office.nominees = this.sortByKey(office.nominees, "vote_count");
            if (office.nominees) {
              office.nominees[0].color = true;
            }
          });
          if (this.selectedElection.result_visible == 1) {
            this.officeArr = officeArr;
          } else {
            this.officeArr = JSON.parse(JSON.stringify(data));
          }
          // this.officeArr = ;
        },
        error => {
          this.snackbar.open("Cannot Fetch Info..", "dismiss", {
            duration: 4000
          });
        }
      );
  }

  sortByKey(array, key) {
    return array.sort(function(a, b) {
      var x = a[key];
      var y = b[key];
      return x > y ? -1 : x < y ? 1 : 0;
    });
  }

  vote(nominee, office) {
    let sheetRef = this.bottomSheet.open(ConfirmSnackbarComponent, {
      data: { message: "Are you sure?", button1: "Yes", button2: "No" }
    });
    sheetRef.afterDismissed().subscribe(data => {
      if (data) {
        if (data.response) {
          this._vote(nominee, office);
        }
      }
    });
  }
  _vote(nominee, { student_office_id }) {
    this.electionService
      .vote({ ...nominee, student_office_id })
      .subscribe(data => {
        if (data.success) {
          this.getOffices();
          this.snackbar.open("Vote Casted!", "dismiss", {
            duration: 4000,
            panelClass: ["snackbar-success"]
          });
          this.log
						.addLog({
						action: "Vote",
						component: "Election",
						details: `Casted a Vote`,
					}).subscribe(data => { });
        } else {
          this.snackbar.open(`${data.message}`, "dismiss", {
            duration: 4000,
            panelClass: ["snackbar-error"]
          });
        }
      });
  }
}
